/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { zIndex } from '@/shared/themes/light/z-index';
import { createPortal } from "react-dom";

type BlackboxProps = {
  blurAmount?: number;
  darkenAmount?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  children?: React.ReactNode;
  [key: string]: any;
};

/**
 * Full-screen overlay with blur and darkening effects, rendered via portal.
 *
 * @param {BlackboxProps} props - Blackbox properties.
 * @returns {React.ReactPortal | null} Portal element or null when empty.
 */
export const Blackbox: React.FC<BlackboxProps> = ({
  blurAmount = 1,
  darkenAmount = 2,
  children,
  ...props
}) => {
  if (!children) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `rgba(0,0,0,${darkenAmount * 0.1})`,
        backdropFilter: `blur(${blurAmount}px)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: zIndex.blackbox,
      }}
      {...props}
    >
      {children}
    </div>,
    document.body
  );
};
